export const ROUTE = {
    ALERT_PAGE: "ALERT_PAGE",
    SPLASH_SCREEN: "SPLASH_SCREEN",
    TEST_PAGE: "TEST_PAGE",
    PHONE_NUMBER: "PHONE_NUMBER",
    ENTER_EMAIL: "ENTER_EMAIL",
    OTP_VERIFY: "OTP_VERIFY",
    EMAIL_VERIFY: "EMAIL_VERIFY",
    KYC_PAN_VERIFICATION: "KYC_PAN_VERIFICATION",
    PAN_CONFIRM_NAME: "PAN_CONFIRM_NAME",
    MF_FETCH_PORTFOLIO: "MF_FETCH_PORTFOLIO",
    UPDATE_PHONE_NUMBER: "UPDATE_PHONE_NUMBER",
    OTP_AUTH_CAS: "OTP_AUTH_CAS",
    VERIFICATION_FAILED: "VERIFICATION_FAILED",
    KYC_AADHAAR_VERIFICATION: "KYC_AADHAAR_VERIFICATION",
    KYC_AADHAAR_VERIFICATION_OTP: "KYC_AADHAAR_VERIFICATION_OTP",
    KYC_SUMMARY: "KYC_SUMMARY",
    BANK_ACCOUNT_VERIFICATION: "BANK_ACCOUNT_VERIFICATION",
    BANK_SELECT: "BANK_SELECT",
    BANK_ACCOUNT_ADD: "BANK_ACCOUNT_ADD",
    BANK_SEARCH_BRANCH: "BANK_BRANCH_SEARCH",
    KYC_STEPPER: "KYC_STEPPER",
    POPUP_LOADER: "POPUP_LOADER",
    KYC_DIGILOCKER: "KYC_DIGIO_DIGILOCKER",
    KYC_PHOTO_VERIFICATION: "KYC_PHOTO_VERIFICATION",
    CAMERA_CAPTURE: "CAMERA_CAPTURE",
    PLEDGE_CONFIRMATION_LOADING: "PLEDGE_CONFIRMATION_LOADING",
    MF_PLEDGE_PORTFOLIO: "MF_PLEDGE_PORTFOLIO",
    PLEDGE_VERIFY: "PLEDGE_VERIFY",
    PLEDGE_LOADING: "PLEDGE_LOADING",
    UNLOCK_SUCCESS: "UNLOCK_SUCCESS",
    PLEDGE_CONFIRMATION: "PLEDGE_CONFIRMATION",
    ASSET_PLEDGE: "ASSET_PLEDGE",
    MODIFY_LIMIT: "MODIFY_LIMIT",
    PORTFOLIO: "PORTFOLIO",
    PLEDGED_AMOUNT: "PLEDGED_AMOUNT",
    MODIFY_PLEDGED_AMOUNT: "MODIFY_PLEDGED_AMOUNT",
    DASHBOARD: "DASHBOARD",
    WITHDRAW_AMOUNT: "WITHDRAW_AMOUNT",
    WITHDRAWAL_OTP: "WITHDRAWAL_OTP",
    WITHDRAWAL_SUCCESS: "WITHDRAWAL_SUCCESS",
    REPAYMENT: "REPAYMENT",
    LOAN_REPAYMENT: "LOAN_REPAYMENT",
    LOAN_WEBVIEW: "LOAN_WEBVIEW",
    LOAN_AUTOPAY: "LOAN_AUTOPAY",
    LOAN_AGREEMENT: "LOAN_AGREEMENT",
    AGREEMENT_WEBVIEW: "AGREEMENT_WEBVIEW",
    ACCOUNT_DETAILS: "ACCOUNT_DETAILS",
    CONTACT_US: "CONTACT_US",
    MY_PROFILE: "MY_PROFILE",
    FAQ: "FAQ",
    ABOUTUS: "ABOUTUS",
    FAQ_DETAILS: "FAQ_DETAILS",
    CAROUSAL_PAGE: "CAROUSAL_PAGE",
    LANDING_PAGE: "LANDING_PAGE",
    TRANSACTIONS: "TRANSACTIONS",
    PRIVACY_POLICY: "PRIVACY_POLICY",
    KYC_ADDITIONAL_DETAILS: "KYC_ADDITIONAL_DETAILS",
    KYC_DOCUMENT_UPLOAD: "KYC_DOCUMENT_UPLOAD",
    UNLOCK_LIMIT_LANDING: "UNLOCK_LIMIT_LANDING",
    DIST_BANK_ACCOUNT_ADD: "DIST_BANK_ACCOUNT_ADD",
    DIST_BANK_ACCOUNT_VERIFICATION: "DIST_BANK_ACCOUNT_VERIFICATION",
    DIST_BANK_SEARCH_BRANCH: "DIST_BANK_SEARCH_BRANCH",
    DIST_BANK_SELECT: "DIST_BANK_SELECT",
    DISTRIBUTOR_PORTFOLIO: "DISTRIBUTOR_PORTFOLIO",
    PORTFOLOIO_START: "PORTFOLOIO_START",
    SELECT_DISTRIBUTOR_PORTFOLIO: "SELECT_DISTRIBUTOR_PORTFOLIO",
    INVESTOR: "INVESTOR",
    ENTER_NAME: "ENTER_NAME",
    DISTRIBUTOR_CLIENT_LIST: "DISTRIBUTOR_CLIENT_LIST",
    DISTRIBUTOR_CLIENT_LIST_STEPPER: "DISTRIBUTOR_CLIENT_LIST_STEPPER",
    DISTRIBUTOR_BASIC_DETAILS_INFO: "DISTRIBUTOR_BASIC_DETAILS_INFO",
    VERIFICATION_FAILED_NEW: "VERIFICATION_FAILED_NEW",
    PORTFOLIO_READONLY: "PORTFOLIO_READONLY",
    SET_CREDIT_LIMIT: "SET_CREDIT_LIMIT",
    PLEDGE_CONFIRMATION_NEW: "PLEDGE_CONFIRMATION_NEW",
    UPDATE_SLIDER_AMOUNT: "UPDATE_SLIDER_AMOUNT",
    KYC_DOCUMENT_UPLOAD_POA: "KYC_DOCUMENT_UPLOAD_POA",
    KYC_DOCUMENT_UPLOAD_POI: "KYC_DOCUMENT_UPLOAD_POI",
    LOAN_AGREEMENT_POLLING: "LOAN_AGREEMENT_POLLING",
    MANAGE_LIMIT: "MANAGE_LIMIT",
    SELECT_SOURCE: "SELECT_SOURCE",
    SET_CREDIT_LIMIT2: "SET_CREDIT_LIMIT2",
    // SET_CREDIT_LIMIT2: "SET_CREDIT_LIMIT2",
    PORTFOLIO_FROM_RTA: "PORTFOLIO_FROM_RTA",
    DETAILS_CONFIRM: "DETAILS_CONFIRM",
    BASIC_DETAILS_START: "BASIC_DETAILS_START",
    CHECK_PARTNER_LIMIT: "CHECK_PARTNER_LIMIT",
    OTP_PARTNER_PORTFOLIO: "OTP_PARTNER_PORTFOLIO",
    PARTNER_MOBILE_UPDATE: "PARTNER_MOBILE_UPDATE",
    PARTNER_EMAIL_UPDATE: "PARTNER_EMAIL_UPDATE",
    CHECKING_LIMIT: "CHECKING_LIMIT",
    PORTFOLIO_UNLOCK: "PORTFOLIO_UNLOCK",
    INTRO_PAGE: 'INTRO_PAGE',
    PARTNER_DASHBOARD: 'PARTNER_DASHBOARD',
    PARTNER_ACTIVE_CUSTOMER: 'PARTNER_ACTIVE_CUSTOMER',
    PARTNER_LEAD: 'PARTNER_LEAD',
    PARTNER_REFERRED_PARTNER: 'PARTNER_REFERRED_PARTNER',
    PARTNER_LED_JOURNEY: 'PARTNER_LED_JOURNEY',
    VOLT_APP: 'VOLT_APP',
    DIGIO_AGREEMENT_SIGN: "DIGIO_AGREEMENT_SIGN",
    DIGIO_MANDATE_SIGN: 'DIGIO_MANDATE_SIGN',
    REGISTER_LEADS: 'REGISTER_LEADS',
    REGISTER_LEADS_SUCCESS: 'REGISTER_LEADS_SUCCESS',
    PAYMENT_START: 'PAYMENT_START',
    PAYMENT_CALLBACK: 'PAYMENT_CALLBACK',
    KYC_DOCUMENTS_UPLOAD_POA_MANUAL: 'KYC_DOCUMENTS_UPLOAD_POA_MANUAL',
    KYC_DOCUMENTS_UPLOAD_POI_MANUAL: 'KYC_DOCUMENTS_UPLOAD_POI_MANUAL',
    KYC_DOCUMENTS_UPLOAD_BASE: 'KYC_DOCUMENTS_UPLOAD_BASE',
    KYC_DOCUMENTS_DIGIO_BASE: 'KYC_DOCUMENTS_DIGIO_BASE',
    CO_BORROWER_LANDING: 'CO_BORROWER_LANDING',
    CO_BORROWER_PAN: 'CO_BORROWER_PAN',
    CO_BORROWER_KYC_DOCUMENTS_UPLOAD_BASE: 'CO_BORROWER_KYC_DOCUMENTS_UPLOAD_BASE',
    CO_BORROWER_DOCUMENTS_UPLOAD_POA_MANUAL: 'CO_BORROWER_DOCUMENTS_UPLOAD_POA_MANUAL',
    CO_BORROWER_DOCUMENTS_UPLOAD_POI_MANUAL: 'CO_BORROWER_DOCUMENTS_UPLOAD_POI_MANUAL',
    CO_BORROWER_ADDITIONAL_DETAILS: 'CO_BORROWER_ADDITIONAL_DETAILS',
    CO_BORROWER_SUMMARY: 'CO_BORROWER_SUMMARY',
    CO_BORROWER_SUMMARY_CONFIRM: 'CO_BORROWER_SUMMARY_CONFIRM',
    CO_BORROWER_PAN_CONFIRM_NAME: 'CO_BORROWER_PAN_CONFIRM_NAME',
    CO_BORROWER_KYC_DIGIO_BASE: 'CO_BORROWER_KYC_DIGIO_BASE',
    PAYMENT_LOADER: 'PAYMENT_LOADER',
    JOINT_HOLDER_NOTIFY: 'JOINT_HOLDER_NOTIFY',
    ASK_MUTUAL_FUND: 'ASK_MUTUAL_FUND',
    NO_MUTUAL_FUND_INSTRUCTION: 'NO_MUTUAL_FUND_INSTRUCTION',
    DIGIO_MODAL: 'DIGIO_MODAL',
    ASK_MUTUAL_FUND_OLD: 'ASK_MUTUAL_FUND_OLD',
    PARTNER_SIGNUP: 'PARTNER_SIGNUP',
    EMPANEL_SUCCESS_MODAL: 'EMPANEL_SUCCESS_MODAL',
    PARTNER_DASHBOARD_V2: 'PARTNER_DASHBOARD_V2',
    INVITE_CLIENT: 'INVITE_CLIENT',
    PARTNER_LOGOUT: 'PARTNER_LOGOUT',
    PARTNER_MENU: 'PARTNER_MENU',
    COLLATERAL: 'COLLATERAL',
    DEMO_VIDEOS: 'DEMO_VIDEOS',
    MY_ACCOUNT: 'MY_ACCOUNT',
    PARTNER_VIEW_DETAIL_LEAD: 'PARTNER_VIEW_DETAIL_LEAD',
    PLATFORM_DASHBOARD: 'PLATFORM_DASHBOARD',
    PLATFORM_LEADS: 'PLATFORM_LEADS',
    PLATFORM_ACTIVE_CUSTOMERS: 'PLATFORM_ACTIVE_CUSTOMERS',
    PLATFORM_LINKED_PARTNERS: 'PLATFORM_LINKED_PARTNERS',
    PLATFORM_SIGN_UP: 'PLATFORM_SIGN_UP',
    PLATFORM_VIEW_DETAILS: 'PLATFORM_VIEW_DETAILS',
    PLATFORM_LOG_OUT: 'PLATFORM_LOG_OUT',
    MARKETING_LEAD: 'MARKETING_LEAD',
    MARKETING_LEAD_OTP: 'MARKETING_LEAD_OTP',
    MARKETING_LEAD_REDIRECT: 'MARKETING_LEAD_REDIRECT',
    KYC_DIGIO_RESPONSE: 'KYC_DIGIO_RESPONSE',
    DIGIO_AUTOPAY_INPROGRESS: 'DIGIO_AUTOPAY_INPROGRESS',
    DIGIO_AUTOPAY_REDIRECTION: 'DIGIO_AUTOPAY_REDIRECTION',
    DIGIO_AUTOPAY_FAILURE: 'DIGIO_AUTOPAY_FAILURE',
    CONTACT_US_CARD: 'CONTACT_US_CARD',
    CHECK_LIMIT_MFC_INIT: 'CHECK_LIMIT_MFC_INIT',
    CHECK_LIMIT_MFC_OTP: 'CHECK_LIMIT_MFC_OTP',
    CHECK_LIMIT_LOADING: 'CHECK_LIMIT_LOADING',
    CHECK_LIMIT_SUCCESS: 'CHECK_LIMIT_SUCCESS',
    CHECK_LIMIT_VIEW_DETAIL: 'CHECK_LIMIT_VIEW_DETAIL',
    CHECK_LIMIT_NO_MF: 'CHECK_LIMIT_NO_MF',
    CHECK_LIMIT_INFO: 'CHECK_LIMIT_INFO',
    CHECK_LIMIT_ALERT_MODAL: 'CHECK_LIMIT_ALERT_MODAL',
    PARTNER_CHECK_LIMIT: 'PARTNER_CHECK_LIMIT',
    EARNING: 'EARNING',
    PARTNER_AUTH: 'PARTNER_AUTH',
    EMAIL_STATEMENT: 'EMAIL_STATEMENT',
    DIGIO_MODAL_CO_BORROWER: 'DIGIO_MODAL_CO_BORROWER',
    PARTNER_CHECK_CUSTOMER_PORFOLIO: 'PARTNER_CHECK_CUSTOMER_PORFOLIO',
    APPLICATION_PENDING_BLOCKING_SCREEN: 'APPLICATION_PENDING_BLOCKING_SCREEN',
    CHECK_CUSTOMER_ELIGIBILITY: 'CHECK_CUSTOMER_ELIGIBILITY',
    DIGIO_AGREEMENT_INPROGRESS: 'DIGIO_AGREEMENT_INPROGRESS',
    DIGIO_AGREEMENT_FAILED: 'DIGIO_AGREEMENT_FAILED',
    KFS_SCREEN: 'KFS_SCREEN',
    CREDIT_LOADING_SCREEN: 'CREDIT_LOADING_SCREEN',
    NAME_MISMATCH: 'NAME_MISMATCH',
    CIBIL_CHECK_LOADING_SCREEN: 'CIBIL_CHECK_LOADING_SCREEN',
    SIGN_DESK_ESIGN: 'SIGN_DESK_ESIGN',
    EMAIL_VERIFY_OTP: 'EMAIL_VERIFY_OTP',
    MANDATE_MODAL: "MANDATE_MODAL",
    DIGIO_DOC_MODAL: "DIGIO_DOC_MODAL",
    BORROWER_LANDING_SCREEN: 'BORROWER_LANDING_SCREEN',
    LOGOUT_SCREEN: 'LOGOUT_SCREEN',
    BAJAJ_DIGIO_KYC_MODAL: 'BAJAJ_DIGIO_KYC_MODAL',
    BAJAJ_DIGIO_CO_BORROWER_KYC_MODAL: 'BAJAJ_DIGIO_CO_BORROWER_KYC_MODAL',
    SUPPORTING_DOCUMENT: 'SUPPORTING_DOCUMENT',
    PHOTO_MISMATCH: 'PHOTO_MISMATCH',
    UPI_IN_PROGRESS: 'UPI_IN_PROGRESS',
    PAYMENT_OPTIONS: 'PAYMENT_OPTIONS',
    STATE_SELECTION: 'STATE_SELECTION',
    FAILED_SCREEN: 'FAILED_SCREEN',
    VIEW_PORTFOLIO_DETAIL: 'VIEW_PORTFOLIO_DETAIL',
    UNPLDEGE_FUNDS: 'UNPLEDGE_FUNDS',
    UNPLEDGE_STATUS: 'UNPLEDGE_STATUS',
    FORECLOSURE: "FORECLOSURE",
    OUTSTANDING_DUES: "OUTSTANDING_DUES",
    ASSET_PLEDGE_V2: "ASSET_PLEDGE_V2",
    REFRESH_FETCH_OTP: "REFRESH_FETCH_OTP",
    COLLATERAL_INTRO_CARD: 'COLLATERAL_INTRO_CARD',
    COLLATERAL_DOWNLOAD_INFO: 'COLLATERAL_DOWNLOAD_INFO',
    PREVIEW_COLLATERAL: 'PREVIEW_COLLATERAL',
    COLLATERAL_LANGUAGE_SELECT: 'COLLATERAL_LANGUAGE_SELECT',
    USER_CONTEXT_500: 'USER_CONTEXT_500',
    PAYMENT_IN_PROGRESS: 'PAYMENT_IN_PROGRESS',
    BAJAJ_AGREEMENT_STEPPER: 'BAJAJ_AGREEMENT_STEPPER',
    BAJAJ_KFS: 'BAJAJ_KFS',
    REVIEW_AGREEMENT_STEPPER: 'REVIEW_AGREEMENT_STEPPER',
    MANAGE_LIMIT_LANDING: 'MANAGE_LIMIT_LANDING',
    VERIFY_INTEREST_CHARGES_ENHANCE_LIMIT: 'VERIFY_INTEREST_CHARGES_ENHANCE_LIMIT',
    PRE_DASHBOARD_SCREEN: 'PRE_DASHBOARD_SCREEN',
    LOAN_RENEWAL_LEARN_MORE_PAGE: 'LOAN_RENEWAL_LEARN_MORE_PAGE',
    LOAN_RENEWAL_LANDING_PAGE: 'LOAN_RENEWAL_LANDING_PAGE',
    LOAN_RENEWAL_VERIFY_SUMMARY_PAGE: 'LOAN_RENEWAL_VERIFY_SUMMARY_PAGE',
    LOAN_RENEWAL_STATUS_PAGE: 'LOAN_RENEWAL_STATUS_PAGE',
    CONFIRM_AMOUNT: 'CONFIRM_AMOUNT',
    WITHDRAW_REQUEST: 'WITHDRAW_REQUEST',
    REPAYMENT_CHARGES_DETAILS_PAGE: 'REPAYMENT_CHARGES_DETAILS_PAGE',
    INTEREST_REPAYMENT_DETAILS: "INTEREST_REPAYMENT_DETAILS",
    INTEREST_REPAYMENT_LEARN_MORE: "INTEREST_REPAYMENT_LEARN_MORE",
    CGTC_INIT: 'CGTC_INIT',
    CGTC_OTP: 'CGTC_OTP',
    CGTC_PROGRESS: 'CGTC_PROGRESS',
    CGTC_SUMMARY: 'CGTC_SUMMARY',
    CGTC_NO_PORTFOLIO: 'CGTC_NO_PORTFOLIO',
    PARTNER_CAPITAL_GAIN: 'PARTNER_CAPITAL_GAIN',
    TRACK_FORECLOSURE: 'TRACK_FORECLOSURE',
    REMOVE_PLEDGE_STEPS: 'REMOVE_PLEDGE_STEPS',
    PLEDGE_HISTORY: 'PLEDGE_HISTORY',
    PLEDGE_DETAILS: 'PLEDGE_DETAILS',
    SHORTFALL_DETAILS_SCREEN: 'SHORTFALL_DETAILS_SCREEN',
    SHORTFALL_INFO_SCREEN: 'SHORTFALL_INFO_SCREEN',
    SHORTFALL_REPAY_SCREEN: 'SHORTFALL_REPAY_SCREEN',
    SHORTFALL_RECOMENDED_REPAY_SCREEN: 'SHORTFALL_RECOMENDED_REPAY_SCREEN',
    PHONE_PAY_PAGE: "PHONE_PAY_PAGE",
    KYC_DIRECT: 'KYC_DIRECT',
    AS_ES_DOCUMENTS_LISTING: 'AS_ES_DOCUMENTS_LISTING',
    AS_ES_INDIVIDUAL_DOCUMENT: 'AS_ES_INDIVIDUAL_DOCUMENT',
    AS_ES_VIEW_DOCUMENT: 'AS_ES_VIEW_DOCUMENT',
    AS_ES_DOCUMENT_IN_REVIEW: 'AS_ES_DOCUMENT_IN_REVIEW',
    AS_ES_DOCUMENT_REJECTED: 'AS_ES_DOCUMENT_REJECTED',
    AS_ES_SAMPLE_DOCUMENT_VIEW: 'AS_ES_SAMPLE_DOCUMENT_VIEW',
    CONTACT_US_CARD_JUPITER: 'CONTACT_US_CARD_JUPITER',
    CONTACT_US_3_CARDS: 'CONTACT_US_3_CARDS',
    CONTACT_US_2_CARDS: 'CONTACT_US_2_CARDS',
    CONTACT_US_1_CARDS: 'CONTACT_US_1_CARDS',
    PAYOUT_DETAILS_SCREEN: 'PAYOUT_DETAILS_SCREEN',
    IFSC_SECTION_SCREEN: 'IFSC_SECTION_SCREEN',
    INTEREST_CALCULATOR: 'INTEREST_CALCULATOR',
    INTEREST_CALCULATOR_APP: 'INTEREST_CALCULATOR_APP',
    KYC_URL_REDIRECT: 'KYC_URL_REDIRECT',
    ALERT_PAGE_ONLY_TITLE: 'ALERT_PAGE_ONLY_TITLE',
    INTEREST_FILTER_SCREEN: 'INTEREST_FILTER_SCREEN',
    CUSTOMER_VIEW_DETAILS_SCREEN: 'CUSTOMER_VIEW_DETAILS_SCREEN',
    CUSTOMER_FILTER_SCREEN: 'CUSTOMER_FILTER_SCREEN',
    RENEWAL_FILTER_SCREEN: 'RENEWAL_FILTER_SCREEN',
    SHORTFALL_FILTER_SCREEN: 'SHORTFALL_FILTER_SCREEN',
    PENDING_CUSTOMER_VIEW_DETAILS_SCREEN: 'PENDING_CUSTOMER_VIEW_DETAILS_SCREEN',
    LENDING_PARTNER_PAGE_MF: 'LENDING_PARTNER_PAGE_MF',
    PRODUCT_DETAILS_PAGE_MF: 'PRODUCT_DETAILS_PAGE_MF',
    DSP_KFS: 'DSP_KFS',
    MY_LOAN_PROFILE: 'MY_LOAN_PROFILE',
    UPDATE_LOGIN_SCREEN: 'UPDATE_LOGIN_SCREEN',
    UPDATE_EMAIL_SCREEN: 'UPDATE_EMAIL_SCREEN',
    UPDATE_DETAILS_SCREEN: 'UPDATE_DETAILS_SCREEN',
    MFC_FETCH_EVALUTE_FUNDS: 'MFC_FETCH_EVALUTE_FUNDS',
    MFC_FETCH_LANDING: 'MFC_FETCH_LANDING',
    SELECT_SOURCE_3: 'SELECT_SOURCE_3',
    SELECT_SOURCE_2: 'SELECT_SOURCE_2',
    SELECT_SOURCE_1: 'SELECT_SOURCE_1',
    MFC_FETCH_ANCHOR: 'MFC_FETCH_ANCHOR',
    CONFIRM_AND_PAYMENT: 'CONFIRM_AND_PAYMENT',
    FLEXI_REPAY: 'FLEXI_REPAY',
};
